import React, { ReactNode } from 'react';
import MoreInfoIcon from "../../UIComponents/moreInfoIcon";

interface LomavisCard1Props {
  title: string;
  helpText?: string;
  additionalClassName?: string;
  children: ReactNode;
}

const LomavisCard1: React.FC<LomavisCard1Props> = ({
  title,
  helpText,
 additionalClassName,
  children
}) => {
  return (
    <div className={`border rounded p-3 card ${additionalClassName ? additionalClassName: ""}`}>
      <div className={"d-flex flex-row justify-content-between mb-3"}>
        <div>
          <h5 className="fw-bold">{title}</h5>
        </div>
        <div className={"px-1"}>
          {helpText && <MoreInfoIcon text={helpText} />}
        </div>
      </div>


      {children}
    </div>
  );
};

export default LomavisCard1;
